export const priorityList = [
    { value: '1', label: 'High' },
    { value: '2', label: 'Medium' },
    { value: '3', label: 'Low' },
  ];

  export const categoryList = [
    { value: '1', label: 'Technical Issue' },
    { value: '2', label: 'Billing Inquiry' },
    { value: '3', label: 'Other' },
  ];

  export const statusList = [
    { value: '1', label: 'Open' },
    { value: '2', label: 'Closed' },
    { value: '3', label: 'Pending' },
  ];
